/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
import {
  Debtor,
  EstimatingProfile,
  jobSheetProfile,
  EmailTemplate
} from "./CommonProps";
import { Email } from "./modals/Appointment";
import { CurrentUser } from "./modals/CurrentUser";
import { setAdminlogin } from "./Services/AdminService";

export class IBodyshopService {
  apiBaseUrl = "https://flowautobody.azurewebsites.net"; //azure
  // apiBaseUrl = "https://api.flowautobody.com" //aws
  redeemDebtorId = "26554869-8bec-4cde-8206-e9313e6f16a7";
  estimateDetails = {};
  jobsheetProfiles: jobSheetProfile[] = [];
  defJobSheeProfile: jobSheetProfile = { id: "", name: "", version: "" };
  dollarEstimatingProfile: EstimatingProfile = null as any;
  allEstimatingProfile: EstimatingProfile[] = [];
  redeemDebtor: Debtor = null as any;
  allDebtors: Debtor[] = [];
  currentUser: CurrentUser ;
  isLinkOpenedFromEmail: boolean = false;
  loggedIn = false;
  jobSelected: any;
  constructor() {
    this.currentUser = JSON.parse(
      localStorage.getItem("currentUser") as any
    ) as any;

    if (this.currentUser) {
      this.getJobsheetProfiles().then(async (res) => {
        if (res.ok) {
          this.jobsheetProfiles = await res.json();
          let def = this.jobsheetProfiles.filter(
            (x) => x.name == "Private/Insurance"
          );
          if (def.length > 0) this.defJobSheeProfile = def[0];
        }
      });
      this.getDebtors().then((res) => {
        if (res.ok) {
          res.json().then((resJSON: Debtor[]) => {
            this.allDebtors = resJSON;
            let redeem = resJSON.filter((x) => x.name == "Redeem");
            if (redeem.length > 0) {
              this.redeemDebtor = redeem[0];
            }
          });
        }
      });
      this.getEstimatingProfiles().then((res) => {
        if (res.ok) {
          res.json().then((resJSON: EstimatingProfile[]) => {
            this.allEstimatingProfile = resJSON;
            let dollar = resJSON.filter((x) => x.name == "Dollars");
            if (dollar.length > 0) {
              this.dollarEstimatingProfile = dollar[0];
            }
          });
        }
      });
    }
  }

  isRedeemedEstimate(debtorId: string) {
    return debtorId == this.redeemDebtorId;
  }

  getEstimatingProfiles() {
    return this.sendRequest(
      this.apiBaseUrl + "/api/iBodyShop/GetEstimatingProfile",
      "GET",
      null
    );
  }
  getDebtors() {
    return this.sendRequest(
      this.apiBaseUrl + "/api/iBodyShop/GetEstimatingDebtors",
      "GET",
      null
    );
  }
  login(data: any) {
    return this.sendRequest(
      this.apiBaseUrl + "/api/iBodyShop/Login",
      "POST",
      data
    );
  }
  logout() {
    localStorage.removeItem("currentUser");
    setAdminlogin(false);
    this.loggedIn = false;
  }

  getJobsheetProfiles() {
    return this.sendRequest(
      this.apiBaseUrl + "/api/iBodyShop/GetJobSheetProfiles",
      "GET",
      null
    );
  }
  getEstimateDetailsById(estimateId: string) {
    return this.sendRequest(
      this.apiBaseUrl + "/api/iBodyShop/GetEstimateDetails/" + estimateId,
      "GET",
      null
    );
  }
  getHighResolutionImageUrl(imageId: string) {
    // launch url in browser
    return this.apiBaseUrl + "/api/iBodyShop/Images/" + imageId;
  }
  async getDocument(id: string) {
    return this.apiBaseUrl + "/api/iBodyShop/GetDocument/" + id;
  }
  getUserData(data: any) {
    let local = JSON.parse(data);
    let user;
    if (local) {
      return (user = {
        estimateId: local["Data"],
        expectedArrival: null,
        expectedPickup: null,
        owner: "",
        paintCode: "",
        isAccepted: null,
        isBookingConfirmed: false,
        dropOffDate: null,
        pickUpDate: null,
        isBookingRequested: false,
        emailId: "",
        workingDays: 0,
        primaryDetailId: "",
        isCarBooked: false
      });
    }
    return null;
  }
  getAllUsers() {
    return this.sendRequest(
      this.apiBaseUrl + "/api/iBodyShop/AllUsers",
      "GET",
      null
    );
  }

  booking(data: any) {
    return this.sendRequest(
      this.apiBaseUrl + "/api/iBodyShop/BookService",
      "POST",
      data
    );
  }
  acceptEstimate(estimateId: string, obj: any) {
    return this.sendRequest(
      this.apiBaseUrl + "/api/iBodyShop/AuthoriseEstimate/" + estimateId,
      "POST",
      obj
    );
  }
  addNotes(estimateId: string, obj: any) {
    return this.sendRequest(
      this.apiBaseUrl + "/api/iBodyShop/AddNotes/" + estimateId,
      "POST",
      obj
    );
  }
  declineEstimate(estimateId: string) {
    let obj = {
      EstimateId: estimateId,
      ReasonForCancel: "Decline Estimate"
    };
    return this.sendRequest(
      this.apiBaseUrl + "/api/iBodyShop/CancelEstimate",
      "POST",
      obj
    );
  }
  updateReferenceNumber(estimateId: string, refNumber: string) {
    let body = {
      estimateId: estimateId,
      ReferralName: "Referral",
      ReferenceNo: refNumber
    };
    return this.sendRequest(
      this.apiBaseUrl + "/api/iBodyShop/UpdateReferral",
      "POST",
      body
    );
  }
  getMyReferals(searchTerm: string) {
    return this.sendRequest(
      this.apiBaseUrl +
        "/api/iBodyShop/SearchEstimates/" +
        encodeURIComponent(searchTerm),
      "GET",
      null
    );
  }
  getRedeemProducts() {
    return this.getMyReferals("RedeemProduct");
  }
  redeemEstimate(
    currEstimateId: string,
    currEstimatePrimaryDetailsId: string,
    redeemEstimateId: string,
    redeemEstimatePrimaryDetailsId: string
  ) {
    let body = {
      SourceEstimateId: currEstimateId,
      SourcePrimatyDetailsId: currEstimatePrimaryDetailsId,
      ImportEstimateId: redeemEstimateId,
      ImportPrimaryDetailsId: redeemEstimatePrimaryDetailsId
    };
    return this.sendRequest(
      this.apiBaseUrl + "/api/iBodyShop/RedeemEstimate",
      "POST",
      body
    );
  }

  async getEmailTemplates(jobId: string, replaceEstimateId?: boolean) {
    return await this.sendRequest(
      this.apiBaseUrl + `/api/iBodyShop/EmailMessageTemplates/${jobId}`,
      "GET",
      null
    ).then(
      async (res: any) => {
        if (res.ok) {
          if (replaceEstimateId) {
            const response = await res.json();
            const filteredResponse = await response.map(
              (each: EmailTemplate) => {
                each.message = each.message.replace("{EstimateId}", jobId);
                return each;
              }
            );
            return filteredResponse;
          } else {
            return await res.json();
          }
        } else {
          return [];
        }
      },
      (error) => {
        return [];
      }
    );
  }

  sendEmail(
    emailBody: string,
    subject: string,
    estimateId: string,
    toAddress?: string
  ) {
    let body = {
      fromName: "Flow Autobody",
      subject: subject,
      body: emailBody,
      bodyIsHtml: true,
      to: [toAddress ? toAddress : "hello@flowautobody.au"],
      cc: ["hello@flowautobody.au"],
      assignedToId: estimateId,
      jobNumber: ""
    };
    return this.sendRequest(
      this.apiBaseUrl + "/api/iBodyShop/EmailSend",
      "POST",
      body
    );
  }

  sendEmailWithTemplate(emailTemplate: Email) {
    return this.sendRequest(
      this.apiBaseUrl + "/api/iBodyShop/EmailSend",
      "POST",
      emailTemplate
    );
  }

  sendRequest(url: string, method: string, data: any) {
    let requestOptions: any = {
      method: method,
      headers: { "Content-Type": "application/json" }
    };
    if (data) {
      requestOptions["body"] = JSON.stringify(data);
    }
    return fetch(url, requestOptions);
  }

  issueJob(id: string) {
    return this.sendRequest(
      this.apiBaseUrl + "/api/iBodyShop/issueJob/" + id,
      "POST",
      this.defJobSheeProfile
    );
  }

  addEstimateFeedback(data: any) {
    return this.sendRequest(
      this.apiBaseUrl + "/api/sharepoint/AddEstimateFeedback",
      "POST",
      data
    );
  }

  addCompleteFeedback(data: any) {
    return this.sendRequest(
      this.apiBaseUrl + "/api/sharepoint/AddCompleteFeedback",
      "POST",
      data
    );
  }

  getImageList(estimateId: string) {
    return this.sendRequest(
      this.apiBaseUrl + "/api/iBodyShop/GetImageList/" + estimateId,
      "POST",
      null
    );
  }

  async getJobSheet(JobSheetId: string) {
    return await this.sendRequest(
      this.apiBaseUrl + `/api/iBodyShop/api/iBodyShop/JobSheet/${JobSheetId}`,
      "GET",
      null
    ).then(
      async (res: any) => {
        if (res.ok) {
          return await res.json();
        } else {
          return [];
        }
      },
      (error) => {
        return [];
      }
    );
  }

  async getCardDetailsById(id: string, getJobSheets: boolean = true) {
    const card: any = await this.getEstimateDetailsById(id).then((result) =>
      result.json()
    );
    let formatedCard: any = {};
    if (card) {
      if (card["productionSummary"] && getJobSheets) {
        let data = await this.getJobSheet(card["header"].jobId);
        let activities = await data.labour.filter((eachActivity: any) => {
          return eachActivity.taskValue !== 0;
        });
        formatedCard.activities = activities.map((eachActivity: any) => {
          return {
            id: eachActivity.id,
            name: eachActivity.description,
            productiveTimeSpentHours: eachActivity.adjustedTotalSpentHours,
            progress: eachActivity.completedTargetHours,
            status: eachActivity.hasBeenStarted ? "Started" : "",
            targetHours: eachActivity.targetHours,
            workerNames: eachActivity.allocations
              ? eachActivity.allocations?.map((activity: any) => {
                  return activity.workerName;
                })
              : [],
            hasLabourRecords: false,
            allocations: eachActivity.allocations,
            hasCRMRecord: false,
            isCustomTask: eachActivity.custom !== null ? true : false
          };
        });
      }
      formatedCard.colour = card["header"]?.vehicle.colour;
      formatedCard.debtor = card["primaryDetail"]?.debtorName;
      formatedCard.departureNote = card["header"]?.departureNote;
      formatedCard.estimateNumber = card["header"]?.estimateNumber;
      formatedCard.estimatedCompletion =
        card["header"]?.jobBooking?.expectedEnd;
      formatedCard.estimatedPickupDateTime =
        card["header"]?.jobBooking?.expectedPickup;
      formatedCard.estimatorName = card["header"]?.estimatorName;
      formatedCard.excess = card["header"]?.excessAmount;

      formatedCard.id = card["header"]?.id;

      formatedCard.imageId = card["header"]?.ImagesList[0]?.defaultImageId;
      formatedCard.image = card["header"]?.ImagesList[0]?.id;
      formatedCard.insurer = card["primaryDetail"]?.debtorName;
      formatedCard.insurerName = formatedCard.insurer;
      formatedCard.isArrival = card["header"]?.jobBooking?.actualArrival
        ? false
        : true;
      formatedCard.isCompleted = card["header"]?.isJobCompleted;
      formatedCard.isOnHold = card["header"]?.isClosed;
      formatedCard.isStarted = card["header"]?.isJobStarted;
      formatedCard.jobId = card["header"]?.jobId;
      formatedCard.jobNumber = card["header"]?.jobNumber;

      formatedCard.lastWorkshopActivityWorkerId =
        card["header"]?.updateByUserId;

      formatedCard.ownerBusinessPhone =
        card["header"]?.owner.contactDetails.businesPhone;
      formatedCard.ownerHomePhone =
        card["header"]?.owner.contactDetails.homePhone;
      formatedCard.ownerMobilePhone =
        card["header"]?.owner.contactDetails.mobilePhone;
      formatedCard.ownerName = card["header"]?.owner.contactDetails.displayName;
      formatedCard.referenceNumber = card["header"]?.referenceNumber;
      formatedCard.registration = card["header"]?.vehicle.registration;
      formatedCard.ownerFirstName = formatedCard.ownerName;

      formatedCard.series = card["header"]?.vehicle.series;

      formatedCard.trackables = card["header"]?.trackables;
      formatedCard.variant = card["header"]?.vehicle.variant;
      formatedCard.vehicleDescription = card["header"]?.vehicle.description;
      formatedCard.vehicleId = card["header"]?.vehicleId;
      formatedCard.vehicleLocation = card["header"]?.vehicleLocation;
      formatedCard.vehicleMake = card["header"]?.vehicle.make;
      formatedCard.vehicleRegistration = card["header"]?.vehicle.registration;
      formatedCard.vehicleModel = card["header"]?.vehicle.model;
      formatedCard.wasTowed = card["header"]?.wasTowed;
      formatedCard.workType = card["header"]?.workType;
      formatedCard.allData = card;
    }

    return formatedCard;
  }
}
